import { z } from 'zod';

export const PermissionSchema = z.object({
  id: z.union([z.string(), z.number()]),
  name: z.string(),
  code: z.string(),
  description: z.string().optional(),
  module: z.string(),
  action: z.string(),
  resource: z.string(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
});

export type Permission = z.infer<typeof PermissionSchema>;

export const PermissionGroupSchema = z.object({
  module: z.string(),
  permissions: z.array(PermissionSchema),
});

export type PermissionGroup = z.infer<typeof PermissionGroupSchema>;
